module.exports = __webpack_public_path__ + "static/media/view event info.55c0ca37.svg";